import React from 'react';
import { useTranslation } from 'react-i18next';
import { Info, Hotel, Users, Coffee, Check } from 'lucide-react';
import type { Venue } from '../types/venue';

interface VenueFactboxProps {
  venue: Venue;
}

export const VenueFactbox: React.FC<VenueFactboxProps> = ({ venue }) => {
  const { t } = useTranslation();
  
  if (!venue.factbox) return null;
  
  return (
    <div className="bg-white rounded-lg shadow-sm overflow-hidden">
      <div className="p-4 border-b">
        <h3 className="font-medium text-gray-800">{t('venues.factbox')}</h3>
      </div>
      
      <div className="p-4 space-y-3">
        <div className="space-y-2">
          {venue.details?.rooms && (
            <div className="flex">
              <span className="text-gray-600 w-40">{t('venues.rooms')}:</span>
              <span className="font-medium">{venue.details.rooms}</span>
            </div>
          )}
          
          {venue.details?.conferenceRooms && (
            <div className="flex">
              <span className="text-gray-600 w-40">{t('venues.conferenceRooms')}:</span>
              <span className="font-medium">{venue.details.conferenceRooms}</span>
            </div>
          )}
          
          {venue.factbox.restaurantCapacity && (
            <div className="flex">
              <span className="text-gray-600 w-40">{t('venues.restaurantCapacity')}:</span>
              <span className="font-medium">{venue.factbox.restaurantCapacity}</span>
            </div>
          )}
          
          {venue.factbox.meetingCapacity && (
            <div className="flex">
              <span className="text-gray-600 w-40">{t('venues.meetingCapacity')}:</span>
              <span className="font-medium">{venue.factbox.meetingCapacity}</span>
            </div>
          )}
          
          {venue.factbox.distance && (
            <div className="flex">
              <span className="text-gray-600 w-40">{t('venues.distance')}:</span>
              <span className="font-medium">{venue.factbox.distance} km</span>
            </div>
          )}
        </div>
      </div>
      
      {venue.factbox.features && venue.factbox.features.length > 0 && (
        <div className="p-4 pt-0">
          <h4 className="text-sm font-medium text-gray-700 mb-2">{t('venues.keyFeatures')}</h4>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-1">
            {venue.factbox.features.map((feature, index) => (
              <li key={index} className="flex items-start text-sm text-gray-600">
                <Check className="w-3 h-3 mr-2 text-green-500 mt-1 flex-shrink-0" />
                {feature}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}; 